var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"v-page-pager"},_vm._l((_vm.pagingCounts),function(num){return _c('li',{class:[num === _vm.pageIndex ? "v-page-li-active":"","v-page-li"],on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.jumpPage(num)}}},[_c('a',[_vm._v(_vm._s(num))])])}))}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a5223a0","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EasyTable/v-pagination/src/pager.vue
// module id = null
// module chunks = 